import { useRef } from 'react';
import { Transition } from 'react-transition-group';
import { useMegaMenuStore } from './UseMegaMenuStore';

const MegaMenuTransition = ({ children, ...props }) => {
  const nodeRef = useRef(null);
  const { menuIsOpen } = useMegaMenuStore();

  return (
    <Transition
      nodeRef={nodeRef}
      in={menuIsOpen}
      timeout={300}
      mountOnEnter
      unmountOnExit
    >
      {(state) => (
        <div
          {...props}
          ref={nodeRef}
          className={`transition absolute inset-x-0 top-0 
                      ${state === 'entering' || state === 'entered' ? 'translate-y-0 opacity-100' : ''}
                      ${state === 'exiting' || state === 'exited' ? '-translate-y-full opacity-0' : ''}
                    `}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};

export default MegaMenuTransition;
